import {useDebugValue} from 'react';

import {noop} from '../../../utils';

import {useEvents} from './';

const defaultDatesEvents = {
    onSettingsChange: noop,
    onCurrentValuesChange: noop,
    onLatestValuesChange: noop,
    onCancel: noop,
    onClose: noop,
    onDateRangeChange: noop,
    onDateRangeClear: noop,
    onDisabledDayClick: noop,
    onFocus: noop,
    onOpen: noop,
    onSelectionModeChange: noop,
    onSubmit: noop
};

function useDatesEvents(props) {
    const {
        datesEvents: propsDatesEvents
    } = props;

    const {
        events: datesEvents
    } = useEvents(defaultDatesEvents, propsDatesEvents);

    const result = {
        datesEvents
    };

    useDebugValue(result);

    return result;
}

export {useDatesEvents};
